import L from 'leaflet';
import { MapContainer, Marker, Polyline, TileLayer, Tooltip } from 'react-leaflet';
import { ContextLabels, FitTo, ProvinceLayer, TILE_ATTR, TILE_URL, useProvinces } from './geo';
import { assetIcon, smeIcon } from './PortfolioMap';

export default function AssetLocationMap({ e, sme, height = 220 }) {
  const geo = useProvinces();
  return (
    <div style={{ height }} className="relative overflow-hidden rounded" data-testid="asset-location-map">
      <MapContainer center={[e.lat, e.lng]} zoom={8} scrollWheelZoom={false} style={{ height: '100%', background: '#0A0F1D' }} zoomControl={false}>
        <TileLayer url={TILE_URL} attribution={TILE_ATTR} maxZoom={16} />
        {geo && <ProvinceLayer geo={geo} stats={{}} selected={e.province} opacity={0.35} />}
        <FitTo geo={geo} code={e.province} padding={[10, 10]} />
        <ContextLabels zoom={9} />
        {sme && <Polyline positions={[[sme.lat, sme.lng], [e.lat, e.lng]]} pathOptions={{ color: '#22D3EE', weight: 1.5, dashArray: '4 4' }} />}
        {sme && <Marker position={[sme.lat, sme.lng]} icon={smeIcon({ health: 'healthy' })}><Tooltip direction="top">{sme.name} — base (synthetic)</Tooltip></Marker>}
        <Marker position={[e.lat, e.lng]} icon={assetIcon(e, true)}><Tooltip direction="top" permanent className="prov-tip">{e.id} · {e.status}</Tooltip></Marker>
      </MapContainer>
      <div className="pointer-events-none absolute left-2 top-2 z-[500] rounded border border-[#2B3B60] bg-[#0A0F1D]/85 px-2 py-1 font-mono text-[10px] text-slate-300">{L.version && 'Province boundary · site · SME base'}</div>
    </div>
  );
}
